export default "__VITE_ASSET__cQAYPmcy__"